<template>
  <el-form ref="form" inline>
    <el-form-item label="公司名称" required>
      <el-select :value="values.company" placeholder="请选择公司" @change="selectCompany">
        <el-option v-for="item in companyList"
                   :key="JSON.stringify(item)"
                   :label="item.companyName"
                   :value="JSON.stringify(item)"/>
      </el-select>
    </el-form-item>
    <el-form-item label="联系人" v-if="values.company">
      <user-auto-complete :value.sync="values.username" @setValue="setUserName"
                          :default-value="defaultUserName"
                          @clear="clearUserName"/>
    </el-form-item>
    <el-form-item label="联系电话" v-if="values.company">
      <el-input v-model="customer.contactInfo" disabled/>
    </el-form-item>
    <el-form-item label="账户名称" v-if="values.company">
      <el-select :value="values.receipt" placeholder="请选择账户名称" @change="selectReceipts">
        <el-option v-for="item in receiptsList"
                   :key="JSON.stringify(item)"
                   :label="item.accountName"
                   :value="JSON.stringify(item)"/>
      </el-select>
    </el-form-item>
    <el-form-item label="开户银行" v-if="values.company">
      <el-input v-model="customer.bank" disabled/>
    </el-form-item>
    <el-form-item label="开户行账号" v-if="values.company">
      <el-input v-model="customer.bankAccount" disabled/>
    </el-form-item>
    <el-form-item label="邮编" v-if="values.company">
      <el-input v-model="customer.postcode"/>
    </el-form-item>
    <el-form-item label="地址" v-if="values.company">
      <el-input v-model="customer.regLocation"/>
    </el-form-item>
  </el-form>
</template>

<script>
/**
 * @Author: 菩萨蛮
 * @Date: 2020/9/3 5:16 下午
 * @Description: 用户form
 * @Version v1.0.0
 *
 * 本组件数据来源有两类，客户本身数据(customerForm拷贝)
 * 公司的业务千篇一的代码好几百行。
 */


export default {
  name: 'UserForm',
  props: {
    cust: {
      type: Object,
      default: null
    },
    isUser: { type: Boolean, default: false }
  },
  data() {
    return {
      customer: {
        companyName: '',
        contactName: '',
        contacts: '',
        contactInfo: '',
        bank: '',
        bankAccount: '',
        postcode: '',
        regLocation: ''
      },
      defaultCustomer: undefined,
      autoComplete: {
        supplier: ''
      },
      values: {
        username: '',
        company: '',
        supplierId: '',
        bank: '',
        receipt: ''
      },
      contactList: [],
      bankInfoList: [],
      companyList: [],
      receiptsList: [],
      isSetDefault: false,
      defaultUserName: null
    };
  },
  async created() {
    await this.initCompany();
    await this.initReceipts();
    this.setDefault();
  },
  watch: {
    cust: {
      deep: true,
      handler() {
        this.setDefault();
      }
    },
    customer: {
      deep: true,
      handler() {
        if (JSON.stringify(this.cust) !== JSON.stringify((this.customer))) {
          this.$emit('update:cust', {
            ...this.cust,
            ...this.customer
          });
        }
      }
    }
  },
  methods: {
    async initReceipts() {
      const user = JSON.parse(localStorage.getItem('user'));
      const { data } = await this.qGet(`/user/companyReceipts/${user.companyId}`);
      this.receiptsList = data;
    },
    async initCompany() {
      const user = JSON.parse(localStorage.getItem('user'));
      const { data } = await this.qGet(`/user/companyInvoices/${user.companyId}`);
      this.companyList = data;
    },
    selectCompany(item) {
      const company = JSON.parse(item);
      this.values.company = item;
      this.customer.companyName = company.companyName;
      this.customer.regLocation = company.registAddr;
    },
    selectReceipts(item) {
      const receipt = JSON.parse(item);
      this.values.receipt = item;
      this.customer.bankName = receipt.accountName;
      this.customer.bank = receipt.bankAccount;
      this.customer.bankAccount = receipt.bankAccountNum;
    },
    setDefault() {
      if (this.cust) {
        this.customer = this.utils.copy(this.cust);
        const customer = this.utils.copy(this.customer);
        this.contactList = this.cust.contactList;
        this.bankInfoList = this.cust.bankInfoList;
        const { isEmpty, notEmptyArr } = this.utils;

        // 初始化公司名称
        if (!isEmpty(this.cust.companyName)) {
          const { companyName, bankAccount } = this.cust;
          const list = this.companyList.filter(e => e.companyName === companyName && e.bankAccountNum === bankAccount);
          if (list && list.length === 1) {
            this.values.company = JSON.stringify(list[0]);
          }
          this.values.company = this.cust.companyName;
        }
        // 初始化联系人
        if (!isEmpty(this.cust.contacts)) {
          this.defaultUserName = this.cust.contacts;
        }
        // 初始化账户名称
        if (!isEmpty(this.cust.bankName)) {
          const { bankName, bankAccount } = this.cust;
          const list = this.receiptsList.filter(e => e.accountName === bankName && e.bankAccountNum === bankAccount);
          if (list && list.length === 1) {
            this.values.receipt = JSON.stringify(list[0]);
          }
        }
      }
    },
    selectBank(item) {
      const bank = JSON.parse(item);
      this.values.bank = item;
      this.customer.bank = bank.openBank;
      this.customer.bankAccount = bank.bankAccount;
      if (!this.utils.isEmpty(bank.regLocation)) {
        this.customer.regLocation = bank.regLocation;
      }

      this.$emit('setDefaultCurrencyUnit', bank.monetaryUnit);
    },
    setUserName(item) {
      this.customer.contacts = item.name;
      this.customer.contactInfo = item.phone;
    },
    clearUserName() {
      this.values.username = '';
      this.customer.contacts = '';
      this.customer.contactInfo = '';
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
